import { createSlice } from "@reduxjs/toolkit";
import secureLocalStorage from "react-secure-storage";

export const loadAuthState = () => {
  try {
    const storedAuth = secureLocalStorage.getItem("auth");
    const storedUser = secureLocalStorage.getItem("user");

    if (storedAuth) {
      return {
        user:
          typeof storedAuth === "string"
            ? JSON.parse(storedAuth)
            : storedAuth,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    }

    if (storedUser) {
      const parsed =
        typeof storedUser === "string"
          ? JSON.parse(storedUser)
          : storedUser;

      return {
        user: parsed?.user || parsed,
        isAuthenticated: true,
        loading: false,
        error: null,
      };
    }

    return {
      user: null,
      isAuthenticated: false,
      loading: false,
      error: null,
    };
  } catch {
    return {
      user: null,
      isAuthenticated: false,
      loading: false,
      error: null,
    };
  }
};

const initialState = loadAuthState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;

      // ✅ CRITICAL FIX: update redux state
      state.user = action.payload;

      // ✅ keep both for backward compatibility
      secureLocalStorage.setItem("auth", JSON.stringify(action.payload));
      secureLocalStorage.setItem(
        "user",
        JSON.stringify({ user: action.payload })
      );

      state.loading = false;
      state.error = null;
    },

    logoutSuccess: (state) => {
      state.isAuthenticated = false;
      state.user = null;

      secureLocalStorage.removeItem("auth");
      secureLocalStorage.removeItem("user");
      secureLocalStorage.removeItem("token");
      secureLocalStorage.removeItem("refreshToken");
    },

    refreshTokenSuccess: (state, action) => {
      if (state.user) {
        state.user.accessToken = action.payload.accessToken;

        secureLocalStorage.setItem("auth", JSON.stringify(state.user));
        secureLocalStorage.setItem(
          "user",
          JSON.stringify({ user: state.user })
        );
      }
    },

    createUserRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    createUserSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },

    createUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loginSuccess,
  logoutSuccess,
  refreshTokenSuccess,
  createUserRequest,
  createUserSuccess,
  createUserFailure,
} = authSlice.actions;

export default authSlice.reducer;